import { promoConfigsApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const checkIfPromoConfigured = (payload) => {
  const url = promoConfigsApi.IS_PROMO_CONFIGURED;
  return axios.post(url, payload);
};
